import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import CompCssClass from "./SaveBSTaskDetails.module.css";
import Checkbox from "@mui/material/Checkbox";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import SnackBar from "components/SnackBar/SnackBar";
import {
  getAskNowBSTaskDetails,
  saveAskNowBSTaskDetails,
} from "services/userServices";
import BackdropComponent from "../../components/Spinner/Spinner";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";
import {
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const OBTSaveBSTaskModal = ({ onClose, projectFullCode, isEdit, props }) => {
  const formControlLabelStyle = {
    "& .MuiFormControlLabel-label": {
      marginLeft: "8px",
      color: "#3f5765",
      fontFamily: "Urbanist",
      fontSize: "14px",
      fontWeight: "bold",
    },
  };

  const [isLoading, setIsLoading] = useState(false);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const [recordAvailable, setRecordAvailable] = useState(false);

  const [bsTaskDetails, setBSTaskDetails] = useState({
    sys_id: "",
    u_create_ske_task: false,
    u_create_branch_office_task: false,
    u_create_qa_systems_task: false,
    u_create_client_id_task: false,
    u_create_ad_account_task: false,
    u_create_sip_bria_provisioning_task: false,
    u_nist_provisioning: false,
    u_red8_pc_provisioning: false,
    u_faneuil_provisioning: false,
    u_agent_desktop: "",
    u_default_user_pw: "",
    u_extension_start: "",
    u_extension_end: "",
    u_agent_desktop_disabled: true,
    u_default_user_pw_disabled: true,
    u_extension_start_disabled: true,
    u_extension_end_disabled: true,
    u_agent_desktop_required: false,
    u_default_user_pw_required: false,
    u_extension_start_required: false,
    u_extension_end_required: false,
  });

  const handleValueChange = (name, value) => {
    if (name === "u_switch_access_type") {
      setBSTaskDetails((prevState) => ({
        ...prevState,
        [name]: value !== "NA" ? value : "",
        u_agent_desktop: "",
        u_default_user_pw: "",
        u_extension_start: "",
        u_extension_end: "",
        u_agent_desktop_required: false,
        u_default_user_pw_required: false,
        u_extension_start_required: false,
        u_extension_end_required: false,
        u_agent_desktop_disabled: !(value === "ccaip" || value === "humanify"),
        u_default_user_pw_disabled: value !== "humanify",
        u_extension_start_disabled: value !== "humanify",
        u_extension_end_disabled: value !== "humanify",
      }));
    } else {
      setBSTaskDetails((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const fetchBSTaskDetails = async () => {
    try {
      setIsLoading(true);

      if (projectFullCode != null && projectFullCode.includes("|") === true) {
        const projectCode = projectFullCode.includes("|")
          ? projectFullCode.split("|")[0]
          : "";

        const response = await getAskNowBSTaskDetails(projectCode);

        if (response?.statusCode === 200) {
          setRecordAvailable(true);

          setBSTaskDetails({
            sys_id: response?.data[0]?.sys_id || "",
            u_create_ske_task: response?.data[0]?.u_create_ske_task || false,
            u_create_branch_office_task:
              response?.data[0]?.u_create_branch_office_task || false,
            u_create_qa_systems_task:
              response?.data[0]?.u_create_qa_systems_task || false,
            u_create_client_id_task:
              response?.data[0]?.u_create_client_id_task || false,
            u_create_ad_account_task:
              response?.data[0]?.u_create_ad_account_task || false,
            u_create_sip_bria_provisioning_task:
              response?.data[0]?.u_create_sip_bria_provisioning_task || false,
            u_nist_provisioning:
              response?.data[0]?.u_nist_provisioning || false,
            u_red8_pc_provisioning:
              response?.data[0]?.u_red8_pc_provisioning || false,
            u_faneuil_provisioning:
              response?.data[0]?.u_faneuil_provisioning || false,
            u_switch_access_type: response?.data[0]?.u_switch_access_type || "",
            u_agent_desktop: response?.data[0]?.u_agent_desktop || "",
            u_default_user_pw: response?.data[0]?.u_default_user_pw || "",
            u_extension_start: response?.data[0]?.u_extension_start || "",
            u_extension_end: response?.data[0]?.u_extension_end || "",
            u_agent_desktop_disabled: !(
              response?.data[0]?.u_switch_access_type === "ccaip" ||
              response?.data[0]?.u_switch_access_type === "humanify"
            ),
            u_default_user_pw_disabled:
              response?.data[0]?.u_switch_access_type !== "humanify",
            u_extension_start_disabled:
              response?.data[0]?.u_switch_access_type !== "humanify",
            u_extension_end_disabled:
              response?.data[0]?.u_switch_access_type !== "humanify",
            u_agent_desktop_required: false,
            u_default_user_pw_required: false,
            u_extension_start_required: false,
            u_extension_end_required: false,
          });
        } else {
          setSnack({
            open: true,
            message: `Records not found on AskNow`,
            severity: "error",
          });
        }
      } else {
        setSnack({
          open: true,
          message: `Project Code is required`,
          severity: "error",
        });
      }
    } catch (error) {
      setSnack({
        open: true,
        message: `Some internal error occured!`,
        severity: "error",
      });
    }

    setIsLoading(false);
  };

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      try {
        await fetchBSTaskDetails();
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch BS task details:", error);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [projectFullCode]);

  const handleSaveBSTaskDetails = async () => {
    try {
      setIsLoading(true);

      let hasError = false;

      if (
        bsTaskDetails.u_switch_access_type === "ccaip" ||
        bsTaskDetails.u_switch_access_type === "humanify"
      ) {
        setBSTaskDetails((prevState) => ({
          ...prevState,
          u_agent_desktop_required:
            !bsTaskDetails.u_agent_desktop_disabled &&
            bsTaskDetails.u_agent_desktop === "",
          u_default_user_pw_required:
            bsTaskDetails.u_switch_access_type === "humanify" &&
            !bsTaskDetails.u_default_user_pw_disabled &&
            bsTaskDetails.u_default_user_pw === "",
          u_extension_start_required:
            bsTaskDetails.u_switch_access_type === "humanify" &&
            !bsTaskDetails.u_extension_start_disabled &&
            bsTaskDetails.u_extension_start === "",
          u_extension_end_required:
            bsTaskDetails.u_switch_access_type === "humanify" &&
            !bsTaskDetails.u_extension_end_disabled &&
            bsTaskDetails.u_extension_end === "",
        }));

        if (
          (!bsTaskDetails.u_agent_desktop_disabled &&
            bsTaskDetails.u_agent_desktop === "") ||
          (bsTaskDetails.u_switch_access_type === "humanify" &&
            !bsTaskDetails.u_default_user_pw_disabled &&
            bsTaskDetails.u_default_user_pw === "") ||
          (bsTaskDetails.u_switch_access_type === "humanify" &&
            !bsTaskDetails.u_extension_start_disabled &&
            bsTaskDetails.u_extension_start === "") ||
          (bsTaskDetails.u_switch_access_type === "humanify" &&
            !bsTaskDetails.u_extension_end_disabled &&
            bsTaskDetails.u_extension_end === "")
        ) {
          hasError = true;
          setSnack({
            open: true,
            message: `Missing for Switch Type: ${
              bsTaskDetails.u_switch_access_type === "ccaip"
                ? "CCAIP"
                : "Humanify"
            }.`,
            severity: "error",
          });
        }
      } else {
        setBSTaskDetails((prevState) => ({
          ...prevState,
          u_agent_desktop_required: false,
          u_default_user_pw_required: false,
          u_extension_start_required: false,
          u_extension_end_required: false,
        }));
      }

      if (!hasError) {
        const jsonPayLoad = {
          u_create_ske_task: bsTaskDetails.u_create_ske_task,
          u_create_branch_office_task:
            bsTaskDetails.u_create_branch_office_task,
          u_create_qa_systems_task: bsTaskDetails.u_create_qa_systems_task,
          u_create_client_id_task: bsTaskDetails.u_create_client_id_task,
          u_create_ad_account_task: bsTaskDetails.u_create_ad_account_task,
          u_create_sip_bria_provisioning_task:
            bsTaskDetails.u_create_sip_bria_provisioning_task,
          u_nist_provisioning: bsTaskDetails.u_nist_provisioning,
          u_red8_pc_provisioning: bsTaskDetails.u_red8_pc_provisioning,
          u_faneuil_provisioning: bsTaskDetails.u_faneuil_provisioning,
          u_switch_access_type: bsTaskDetails.u_switch_access_type,
          u_agent_desktop: bsTaskDetails.u_agent_desktop,
          u_default_user_pw: bsTaskDetails.u_default_user_pw,
          u_extension_start: bsTaskDetails.u_extension_start,
          u_extension_end: bsTaskDetails.u_extension_end,
        };

        const saveBSTaskDetails = await saveAskNowBSTaskDetails(
          bsTaskDetails.sys_id,
          jsonPayLoad,
        );

        if (saveBSTaskDetails.statusCode === 200) {
          setSnack({
            open: true,
            message: "Saved BS Task on AskNow.",
            severity: "success",
          });
        }
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setSnack({
        open: true,
        message: "Some internal error occured",
        severity: "error",
      });
    }
  };

  return (
    <>
      {isLoading ? <BackdropComponent /> : null}
      <div className={CompCssClass.mainContainer}>
        <Box
          sx={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#2B3A42",
              fontFamily: "Urbanist",
              flexGrow: 1,
            }}
          >
            AskNow Business Services
          </Typography>
          <CloseIcon
            onClick={onClose}
            sx={{
              fontSize: "23px",
              marginLeft: "16rem",
              cursor: "pointer",
            }}
          />
        </Box>

        <Grid className="align-center" container rowSpacing={2} columns={1}>
          <Grid
            sx={{ marginTop: "7px" }}
            container
            className="align-center"
            justify="flex-end"
            alignItems="center"
            spacing={1}
          >
            <Grid
              sx={{
                color: "#3f5765",
                fontFamily: "Urbanist",
                fontSize: "14px",
                fontWeight: "bold",
              }}
              item
              xs={6}
            >
              Client Code:
            </Grid>
            <Grid
              sx={{
                color: "#3f5765",
                fontFamily: "Urbanist",
                fontSize: "14px",
                fontWeight: "bold",
              }}
              item
              xs={6}
            >
              Project:
            </Grid>
            <Grid item xs={5.7} sx={{ marginRight: "10px" }}>
              <TextField
                fullWidth
                size="small"
                disabled={true}
                name="u_client_code"
                value={projectFullCode ? projectFullCode.split("|")[0] : ""}
                placeholder="Client Code"
              />
            </Grid>
            <Grid item xs={5.7} sx={{ marginLeft: "5px" }}>
              <TextField
                fullWidth
                size="small"
                disabled={true}
                name="name"
                value={projectFullCode ? projectFullCode.split("|")[1] : ""}
                placeholder="Project"
              />
            </Grid>
          </Grid>
          <Grid
            className="align-center"
            container
            rowSpacing={2}
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            columns={8}
          >
            <Grid item xs={4}>
              &nbsp;
            </Grid>
            <Grid item xs={4}>
              &nbsp;
            </Grid>
          </Grid>

          <Grid
            sx={{ marginTop: "10px" }}
            className={CompCssClass.gridBorder}
            container
            spacing={1}
            columnSpacing={1}
          >
            <Grid
              item
              xs={3.3}
              sx={{
                marginBottom: "10px",
                paddingTop: "15px",
                marginTop: "5px",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!recordAvailable}
                    checked={bsTaskDetails.u_create_ske_task || false}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.checked)
                    }
                    name="u_create_ske_task"
                  />
                }
                label="Create LMS?"
                sx={{ ...formControlLabelStyle }}
              />
            </Grid>
            <Grid
              item
              xs={4.7}
              sx={{
                marginBottom: "10px",
                paddingTop: "15px",
                marginTop: "5px",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!recordAvailable}
                    checked={bsTaskDetails.u_create_branch_office_task || false}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.checked)
                    }
                    name="u_create_branch_office_task"
                  />
                }
                label="Create IDM TTEC Address"
                labelPlacement="end"
                sx={{ ...formControlLabelStyle }}
              />
            </Grid>
            <Grid
              item
              xs={4}
              sx={{
                marginBottom: "10px",
                paddingTop: "15px",
                marginTop: "5px",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!recordAvailable}
                    checked={bsTaskDetails.u_create_qa_systems_task || false}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.checked)
                    }
                    name="u_create_qa_systems_task"
                  />
                }
                label="Create QA Systems"
                labelPlacement="end"
                sx={{ ...formControlLabelStyle }}
              />
            </Grid>
            <Grid item xs={3.3} sx={{ marginBottom: "15px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!recordAvailable}
                    checked={bsTaskDetails.u_create_client_id_task || false}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.checked)
                    }
                    name="u_create_client_id_task"
                  />
                }
                label="Create Client ID"
                labelPlacement="end"
                sx={{ ...formControlLabelStyle }}
              />
            </Grid>
            <Grid item xs={4.7} sx={{ paddingTop: "15px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!recordAvailable}
                    checked={
                      bsTaskDetails.u_create_sip_bria_provisioning_task || false
                    }
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.checked)
                    }
                    name="u_create_sip_bria_provisioning_task"
                  />
                }
                label="Create IDM SIP / BRIA"
                labelPlacement="end"
                sx={{ ...formControlLabelStyle }}
              />
            </Grid>
            <Grid item xs={4} sx={{ paddingTop: "15px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!recordAvailable}
                    checked={bsTaskDetails.u_create_ad_account_task || false}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.checked)
                    }
                    name="u_create_ad_account_task"
                  />
                }
                label="Create AD Account?"
                labelPlacement="end"
                sx={{ ...formControlLabelStyle }}
              />
            </Grid>
            <Grid item xs={3.3} sx={{ paddingTop: "15px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!recordAvailable}
                    checked={bsTaskDetails.u_faneuil_provisioning || false}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.checked)
                    }
                    name="u_faneuil_provisioning"
                  />
                }
                label="Create Faneuil?"
                labelPlacement="end"
                sx={{ ...formControlLabelStyle }}
              />
            </Grid>
            <Grid item xs={4.7} sx={{ paddingTop: "15px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!recordAvailable}
                    checked={bsTaskDetails.u_red8_pc_provisioning || false}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.checked)
                    }
                    name="u_red8_pc_provisioning"
                  />
                }
                label="Create Site IT HW?"
                labelPlacement="end"
                sx={{ ...formControlLabelStyle }}
              />
            </Grid>
            <Grid item xs={4} sx={{ paddingTop: "15px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!recordAvailable}
                    checked={bsTaskDetails.u_nist_provisioning || false}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.checked)
                    }
                    name="u_nist_provisioning"
                  />
                }
                label="Create NIST?"
                labelPlacement="end"
                sx={{ ...formControlLabelStyle }}
              />
            </Grid>
            <Grid item xs={4}>
              &nbsp;
            </Grid>
          </Grid>

          <Grid className="align-center" container>
            <Grid item xs={8}>
              &nbsp;
            </Grid>
          </Grid>

          <Grid container>
            <Grid
              sx={{
                color: "#3f5765",
                fontFamily: "Urbanist",
                fontSize: "14px",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
              item
              xs={8}
            >
              Switch Access Type:
            </Grid>
            <Grid item xs={8} sx={{ marginBottom: "10px" }}>
              <FormControl sx={{ minWidth: 220 }} size="small">
                <Select
                  sx={{
                    color: "#3f5765",
                    fontFamily: "Urbanist",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                  disabled={!recordAvailable}
                  name="u_switch_access_type"
                  value={bsTaskDetails.u_switch_access_type || "NA"}
                  onChange={(event) =>
                    handleValueChange(event.target.name, event.target.value)
                  }
                >
                  <MenuItem value="NA">Select</MenuItem>
                  <MenuItem value="Avaya">Avaya</MenuItem>
                  <MenuItem value="ccaip">CCAIP</MenuItem>
                  <MenuItem value="Cisco">Cisco</MenuItem>
                  <MenuItem value="Faneuil Cisco">Faneuil Cisco</MenuItem>
                  <MenuItem value="genesys">Genesys</MenuItem>
                  <MenuItem value="humanify">Humanify</MenuItem>
                  <MenuItem value="SIP/Bria">SIP/Bria</MenuItem>
                  <MenuItem value="Client">Client</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid
              sx={{
                color: "#3f5765",
                fontFamily: "Urbanist",
                fontSize: "14px",
                marginBottom: "10px",
                fontWeight: "bold",
              }}
              item
              xs={7.5}
            >
              <b>Switch Access Details</b>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    fontFamily: "Urbanist",
                    color: bsTaskDetails.u_agent_desktop_required
                      ? "red"
                      : "#3f5765",
                  }}
                >
                  {!bsTaskDetails.u_agent_desktop_disabled && (
                    <Box
                      component="sup"
                      sx={{
                        color: "red",
                      }}
                    >
                      *
                    </Box>
                  )}
                  Agent Desktop
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    fontFamily: "Urbanist",
                    color: bsTaskDetails.u_default_user_pw_required
                      ? "red"
                      : "#3f5765",
                  }}
                >
                  {!bsTaskDetails.u_default_user_pw_disabled && (
                    <Box
                      component="sup"
                      sx={{
                        color: "red",
                      }}
                    >
                      *
                    </Box>
                  )}
                  Default User PW
                </Typography>
              </Grid>
              <Grid
                item
                xs={5.7}
                sx={{ marginBottom: "10px", marginRight: "10px" }}
              >
                <TextField
                  fullWidth
                  name="u_agent_desktop"
                  size="small"
                  disabled={bsTaskDetails.u_agent_desktop_disabled}
                  required={bsTaskDetails.u_agent_desktop_required}
                  error={bsTaskDetails.u_agent_desktop_required}
                  placeholder="Input"
                  value={bsTaskDetails.u_agent_desktop || ""}
                  onChange={(event) =>
                    handleValueChange(event.target.name, event.target.value)
                  }
                  InputProps={{
                    sx: {
                      color: "#3f5765",
                    },
                    endAdornment: bsTaskDetails.u_agent_desktop && (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="clear input"
                          onClick={(event) =>
                            handleValueChange("u_agent_desktop", "")
                          }
                          edge="end"
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid
                item
                xs={5.7}
                sx={{ marginBottom: "10px", marginLeft: "5px" }}
              >
                <TextField
                  fullWidth
                  name="u_default_user_pw"
                  size="small"
                  disabled={bsTaskDetails.u_default_user_pw_disabled}
                  required={bsTaskDetails.u_default_user_pw_required}
                  error={bsTaskDetails.u_default_user_pw_required}
                  placeholder="Input"
                  value={bsTaskDetails.u_default_user_pw || ""}
                  onChange={(event) =>
                    handleValueChange(event.target.name, event.target.value)
                  }
                  InputProps={{
                    sx: {
                      color: "#3f5765",
                    },
                    endAdornment: bsTaskDetails.u_default_user_pw && (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="clear input"
                          onClick={(event) =>
                            handleValueChange("u_default_user_pw", "")
                          }
                          edge="end"
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    fontFamily: "Urbanist",
                    color: bsTaskDetails.u_extension_start_required
                      ? "red"
                      : "#3F5765",
                  }}
                >
                  {!bsTaskDetails.u_extension_start_disabled && (
                    <Box
                      component="sup"
                      sx={{
                        color: "red",
                      }}
                    >
                      *
                    </Box>
                  )}
                  Extension Start
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    fontFamily: "Urbanist",
                    color: bsTaskDetails.u_extension_end_required
                      ? "red"
                      : "#3F5765",
                  }}
                >
                  {!bsTaskDetails.u_extension_end_disabled && (
                    <Box
                      component="sup"
                      sx={{
                        color: "red",
                      }}
                    >
                      *
                    </Box>
                  )}
                  Extension End
                </Typography>
              </Grid>
              <Grid item xs={5.7} sx={{ marginRight: "10px" }}>
                <TextField
                  fullWidth
                  name="u_extension_start"
                  size="small"
                  disabled={bsTaskDetails.u_extension_start_disabled}
                  required={bsTaskDetails.u_extension_start_required}
                  error={bsTaskDetails.u_extension_start_required}
                  placeholder="Input"
                  value={bsTaskDetails.u_extension_start || ""}
                  onChange={(event) =>
                    handleValueChange(event.target.name, event.target.value)
                  }
                  InputProps={{
                    sx: {
                      color: "#3f5765",
                    },
                    endAdornment: bsTaskDetails.u_extension_start && (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="clear input"
                          onClick={(event) =>
                            handleValueChange("u_extension_start", "")
                          }
                          edge="end"
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={5.7} sx={{ marginLeft: "5px" }}>
                <TextField
                  fullWidth
                  name="u_extension_end"
                  size="small"
                  disabled={bsTaskDetails.u_extension_end_disabled}
                  required={bsTaskDetails.u_extension_end_required}
                  error={bsTaskDetails.u_extension_end_required}
                  placeholder="Input"
                  value={bsTaskDetails.u_extension_end || ""}
                  onChange={(event) =>
                    handleValueChange(event.target.name, event.target.value)
                  }
                  InputProps={{
                    sx: {
                      color: "#3f5765",
                    },
                    endAdornment: bsTaskDetails.u_extension_end && (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="clear input"
                          onClick={(event) =>
                            handleValueChange("u_extension_end", "")
                          }
                          edge="end"
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <div className={CompCssClass.buttonContainer} justify="flex-end">
            <Grid item xs={2}>
              {recordAvailable && (
                <Button
                  sx={{
                    textTransform: "none",
                    borderRadius: "7px",
                    borderColor: "#1a8cff",
                    marginLeft: "27rem",
                  }}
                  variant="outlined"
                  onClick={onClose}
                >
                  Cancel
                </Button>
              )}
            </Grid>
            <Grid item xs={2}>
              {recordAvailable && (
                <Button
                  sx={{
                    textTransform: "none",
                    borderRadius: "7px",
                    marginLeft: "15%",
                    backgroundColor: "#3299FF",
                  }}
                  variant="contained"
                  onClick={handleSaveBSTaskDetails}
                  disabled={!isEdit}
                >
                  Save
                </Button>
              )}
            </Grid>
          </div>
        </Grid>
        <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
      </div>
    </>
  );
};

OBTSaveBSTaskModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  projectFullCode: PropTypes.string.isRequired,
  isEdit: PropTypes.bool.isRequired,
};

export default OBTSaveBSTaskModal;
